import type { EditAsideCheckbox } from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { get, set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentEditNode } from '../../../hooks/UseCurrentEditNode';
import { useEditHref } from '../../../hooks/UseEditHref';
import SimpleCheckbox from '../../SimpleCheckbox';

const AsideCheckbox: React.FC<{
  config: EditAsideCheckbox;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const editHref = useEditHref();

  const currentEditNode = useCurrentEditNode();
  const checked = Boolean(get(currentEditNode, config.property, false));

  const change = (value: boolean) => {
    dispatch(patchNodeAction(getResourceKey(editHref), set({}, config.property, value)));
  };

  return (
    <SimpleCheckbox checked={checked} label={config.label} readOnly={readonly} onChange={change} />
  );
};

export default AsideCheckbox;

AsideCheckbox.displayName = 'AsideCheckbox';

AsideCheckbox.propTypes = {
  config: any,
  readonly: any,
};
